 <template>
    <div>
      <div class="md-layout">
        <div class="md-layout-item title-bread md-size-100">
          <div class="md-layout dropdowns-buttons">
            <div class="md-layout-item md-size-20 md-small-size-35 md-xsmall-size-40 pull-left regions-title">
              <span class="title">AgBI - Comparativa</span>
              <span class="title-mobile">Comparativa</span>
              <i class="fa fa-info-circle video-icon" aria-hidden="true" @click="videoModal = true"></i>
            </div>
            <menu-selector :regions="regions"
                           :crops="crops"
                           @set-regions="setSelectedRegions"
                           @set-crops="setSelectedCrops"
                           @crop-or-region="setCRColumnSelected"/>
          </div>
        </div>
      </div>
      <margins-menu :tableData="tableData"
                    :data="data"
                    :regionSelected="regionSelected"
                    :cropSelected="cropSelected"
                    @margins-changed="updateTableData"
                    @reset-column="resetColumn"
                     />
      <comparative-table :data="tableData" />
      <div class="md-layout-item md-size-100 graph-data-container">
        <cost v-if="ready" :data="graphData" :key="keyGraph"/>
      </div>
      <modal @close="closeModal" v-if="displayModal" class="advertising-modal">
          <template slot="body">
              <img src="img/adv.png" style="max-height: 500px">
          </template>
          <template slot="footer">
              <md-button class="md-danger md-simple" @click="closeModal">Cerrar</md-button>
          </template>
      </modal>
      <video-modal @close="closeVideoModal" v-if="videoModal">
        <template slot="body">
          <iframe class="md-image" width="800" height="400" src="https://www.youtube.com/embed/-ObFWdOW5hM" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen></iframe>
        </template>
        <template slot="footer">
          <md-button class="md-danger md-simple" @click="closeVideoModal">Cerrar</md-button>
        </template>
      </video-modal>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Cost from '@/components/Comparative/Cost'
import Modal from '@/components/Modal'
import MarginsMenu from '@/components/Comparative/MarginsMenu'
import ComparativeTable from '@/components/Comparative/ComparativeTable'
import MenuSelector from '@/components/Comparative/MenuSelector'
import InfoIcon from "../components/InfoIcon";
import VideoModal from '@/components/VideoModal'

export default {
  components: {Cost, Modal, MarginsMenu, ComparativeTable, MenuSelector, InfoIcon, VideoModal},
  computed: {
    ...mapState(['regions','crops','data','headers','info'])
  },
  data ()  {
    return {
      margins: [
        'Margen Bruto',
        'Margen Neto',
        'Rentabilidad',
        'Rinde de Equilibrio',
        'Precio de Equilibrio',
        'Inversión',
        'Costo de cultivo',
        'Ciclo'],
      units: ['(USD/ha)', '(USD/ha)','(%)','(qq/ha)','(USD/t)','(USD/ha)','(USD/ha)', '(Meses)'],
      ready: false,
      keyGraph: 0,
      displayModal: false,
      selectedColumn: 1,
      selectedCRColumn: 1,
      columnChanged:[0,0,0,0,0],
      tableData: [],
      graphData: {
        xAxis: [],
        margins:[]
      },
      regionSelected: {},
      cropSelected: {},
      videoModal: false,
    }
  },

  methods: {
    closeVideoModal() {
      this.videoModal= false;
    },
    closeModal() {
      this.displayModal= false;
    },
    setSelectedCrops(crops) { this.cropSelected = crops },
    setSelectedRegions(regions) { this.regionSelected = regions },

    getDataRow(payload) {
      let response = [];
      for (let key in this.data)
        if (this.data[key][0] == payload.regionSelected  && this.data[key][1] == payload.cropSelected ) {
          let row = this.data[key];
          for (let index in row){
            response[this.headers[index]] = row[index];
          }
        }
      return response;
    },
    getCellValue(crop, region, option) {
      if (crop == 'Cultivo' || region == 'Region')
        return '';
      let row = this.getDataRow({cropSelected: crop, regionSelected: region});
      if (row[option])
        if (row[option] != '-')
          return parseInt(row[option])
        else
          return '-';
      return 0;
    },
    getMarginCode(option) {
      switch(option){
      case 'Margen Bruto': return 'margen_bruto'; break;
      case 'Margen Neto': return 'margen_neto'; break;
      case 'Rentabilidad': return 'renta'; break;
      case 'Rinde de Equilibrio': return 'rinde_equilibrio'; break;
      case 'Precio de Equilibrio': return 'precio_equilibrio'; break;
      case 'Inversión': return 'inversion'; break;
      case 'Ciclo': return 'ciclo'; break;
      case 'Costo de cultivo': return 'costo_cultivo'; break;
      }
    },

    loadGraphData(element, index) {
      this.graphData.xAxis = [
        this.regionSelected.one+'-'+this.cropSelected.one,
        this.regionSelected.two+'-'+this.cropSelected.two,
        this.regionSelected.three+'-'+this.cropSelected.three,
        this.regionSelected.four+'-'+this.cropSelected.four,
      ];

      this.graphData.margins[index] = [element.column1, element.column2, element.column3, element.column4];

      this.$nextTick(function(){
        this.ready = true;
        this.keyGraph++;
      })


    },

    formatIntegerValue(value){
      if (value != '-')
        return parseInt(value);
      return '-';
    },

    getCurrentCellValue(column, index) {

      switch (column) {
      case 1: return this.tableData[index].column1; break;
      case 2: return this.tableData[index].column2; break;
      case 3: return this.tableData[index].column3; break;
      case 4: return this.tableData[index].column4; break;
      }

    },
    resetColumn(column) {

      this.tableData.map((item, index) => {
        switch(column) {
        case 1: item.column1 = this.formatIntegerValue(this.getCellValue(this.cropSelected.one, this.regionSelected.one, this.getMarginCode(this.margins[index]))); break;
        case 2: item.column2 = this.formatIntegerValue(this.getCellValue(this.cropSelected.two, this.regionSelected.two, this.getMarginCode(this.margins[index]))); break;
        case 3: item.column3 = this.formatIntegerValue(this.getCellValue(this.cropSelected.three, this.regionSelected.three, this.getMarginCode(this.margins[index]))); break;
        case 4: item.column4 = this.formatIntegerValue(this.getCellValue(this.cropSelected.four, this.regionSelected.four, this.getMarginCode(this.margins[index]))); break;

        }
        this.loadGraphData(item, index);
      });
    },

    loadTableData() {
      this.ready = false;


      this.margins.map((item, index) => {
        let element = {};
        element.name = item+' '+this.units[index];
        if (this.columnChanged[1] && this.selectedColumn != this.selectedCRColumn)
          element.column1 = this.getCurrentCellValue(1, index);
        else
          element.column1 = this.getCellValue(this.cropSelected.one, this.regionSelected.one, this.getMarginCode(item));
        if (this.columnChanged[2] && this.selectedColumn != this.selectedCRColumn)
          element.column2 = this.getCurrentCellValue(2, index);
        else
          element.column2 = this.getCellValue(this.cropSelected.two, this.regionSelected.two, this.getMarginCode(item));
        if (this.columnChanged[3] && this.selectedColumn != this.selectedCRColumn)
          element.column3 = this.getCurrentCellValue(3, index);
        else
          element.column3 = this.getCellValue(this.cropSelected.three, this.regionSelected.three, this.getMarginCode(item));
        if (this.columnChanged[4] && this.selectedColumn != this.selectedCRColumn)
          element.column4 = this.getCurrentCellValue(4, index);
        else
          element.column4 = this.getCellValue(this.cropSelected.four, this.regionSelected.four, this.getMarginCode(item));

        element.max = Math.max(element.column1,element.column2,element.column3,element.column4);
        element.min = Math.min(element.column1,element.column2,element.column3,element.column4);

        this.$set(this.tableData,index,element);
        this.loadGraphData(element, index);

      });
    },

    setCRColumnSelected(column) {
      this.selectedCRColumn = column;
      this.loadTableData();
    },
    getDataRowByColumn(column) {
      switch(column) {
      case 1: return this.getDataRow({regionSelected: this.regionSelected.one, cropSelected: this.cropSelected.one }); break;
      case 2: return this.getDataRow({regionSelected: this.regionSelected.two, cropSelected: this.cropSelected.two }); break;
      case 3: return this.getDataRow({regionSelected: this.regionSelected.three, cropSelected: this.cropSelected.three }); break;
      case 4: return this.getDataRow({regionSelected: this.regionSelected.four, cropSelected: this.cropSelected.four }); break;
      }
    },
    getMargenBruto(data) {
      // SIMPLE
      if (!data.precio.doble){
        // Margen Bruto: (precio_c1_e - gtos_comerciales_c1_o) * (rinde_c1_e/10) - costo_c1_s_alq_e
        console.log('Margen Bruto:', '('+data.precio.value1+'-'+data.gtocom.info.value1+') * ('+data.rinde.value1+'/10) - '+data.ctocul.value1 );
        return parseInt(((data.precio.value1 - data.gtocom.info.value1) * (data.rinde.value1 / 10)) - data.ctocul.value1);
      }
      else{
        // DOBLE
        // ((precio_c2_e - gtos_comerciales_c2_o) * (rinde_c2_e / 10) - costo_c2_s_alq_e)) + ((precio_c1_e - gtos_comerciales_c1_o) * (rinde_c1_e / 10) - costo_c1_s_alq_e)
        return parseInt(((data.precio.value2 - data.gtocom.info.value2) * (data.rinde.value2 / 10) - data.ctocul.value2) + ((data.precio.value1 - data.gtocom.info.value1) * (data.rinde.value1 / 10) - data.ctocul.value1));
      }
    },
    getMargenNeto(data) {
      // SIMPLE
      if (!data.precio.doble)
      // Margen Neto: MARGEN BRUTO ANTERIOR - alquiler_c1_o
        return parseFloat(this.getMargenBruto(data) - data.alquiler.info.value1);
      else
      // DOBLE
      // MARGEN BRUTO ANTERIOR - alquiler_c1_o - alquiler_c2_o
        return parseFloat(this.getMargenBruto(data) - data.alquiler.info.value1 - data.alquiler.info.value2 );
    },
    getInversion(data, column) {
      //SIMPLE
      let dataRow = this.getDataRowByColumn(column);
      let cosecha_c1 = parseFloat(dataRow['cosecha_c1']);
      let cosecha_c2= parseFloat(dataRow['cosecha_c2']);
      if (!data.precio.doble)
      // Inversion: costo_c1_s_alq_e + alquiler_c1_o - cosecha_c1
        return parseInt(data.ctocul.value1 + parseFloat(data.alquiler.info.value1) - cosecha_c1 );
      else
      // DOBLE
      // costo_c2_s_alq_e + alquiler_c2_o - cosecha_c2 + costo_c1_s_alq_e + alq_c1_o - cosecha_c1
        return parseInt(data.ctocul.value2 + parseFloat(data.alquiler.info.value2) - cosecha_c2 + data.ctocul.value1 + parseFloat(data.alquiler.info.value1) - cosecha_c1 );
    },
    getCostoCultivo(data, column) {
      let dataRow = this.getDataRowByColumn(column);
      let cosecha_c1 = parseFloat(dataRow['cosecha_c1']);
      let cosecha_c2= parseFloat(dataRow['cosecha_c2']);
      //SIMPLE
      // Costo de cultivo: INVERSION ANTERIOR + cosecha_c1
      if (!data.precio.doble)
        return parseInt(this.getInversion(data, column) + cosecha_c1 );
      else
      // DOBLE
      // INVERSION ANTERIOR + cosecha_c1 + cosecha_c2
        return parseInt(this.getInversion(data, column) + cosecha_c1 + cosecha_c2)


    },
    getRentabilidad(data, column) {
      //SIMPLE
      if (!data.precio.doble)
      // Rentabilidad: (MARGEN NETO ANTERIOR / INVERSION ANTERIOR) * 100
        return parseInt((this.getMargenNeto(data) / this.getInversion(data, column)) * 100);
      else
      // DOBLE (MARGEN NETO ANTERIOR / INVERSION ANTERIOR) * 100
        return parseInt((this.getMargenNeto(data) / this.getInversion(data, column)) * 100);

    },
    getRindeEquilibrio(data, column) {
      //SIMPLE
      // Rinde de equilibrio: (COSTO DE CULTIVO ANTERIOR / (precio_c1_e - gtos_comerciales_c1_o)) * 10
      if (!data.precio.doble)
        return parseInt((this.getCostoCultivo(data, column) / (data.precio.value1 - data.gtocom.info.value1)) * 10);
      else
      // DOBLE
        return '-';
    },
    getPrecioEquilibrio(data, column) {
      //SIMPLE
      // Precio de equilibrio: (COSTO DE CULTIVO ANTERIOR / rinde_c1_e * 10) + gtos_comerciales_c1_o
      if (!data.precio.doble)
        return parseInt(((this.getCostoCultivo(data, column) / data.rinde.value1) * 10 ) + data.gtocom.info.value1);
      else
      // DOBLE
        return '-';
    },


    getCiclo(column) {
      let dataRow = this.getDataRowByColumn(column);

      return parseInt(dataRow['ciclo']);
    },
    getColumnData(column, data, index) {
      switch (index) {
      case 0 : return this.getMargenBruto(data); break;
      case 1 : return this.getMargenNeto(data); break;
      case 2 : return this.getRentabilidad(data, column); break;
      case 3 : return this.getRindeEquilibrio(data, column); break;
      case 4 : return this.getPrecioEquilibrio(data, column); break;
      case 5 : return this.getInversion(data, column); break;
      case 6 : return this.getCostoCultivo(data, column); break;
      case 7 : return this.getCiclo(column); break;
      }
    },
    updateTableData(selectedColumn, dataColumn1, dataColumn2, dataColumn3, dataColumn4) {
      this.selectedColumn = selectedColumn;

      this.tableData.map((item, index) => {
        switch(selectedColumn) {
        case 1: item.column1 = this.getColumnData(1, dataColumn1, index); break; // Calculo en base al crop y region
        case 2: item.column2 = this.getColumnData(2, dataColumn2, index); break;
        case 3: item.column3 = this.getColumnData(3, dataColumn3, index); break;
        case 4: item.column4 = this.getColumnData(4, dataColumn4, index); break;

        }
        this.loadGraphData(item, index);
      });

      this.columnChanged[selectedColumn] = 1;


    }
  },
  mounted() {
    this.loadTableData();
    setTimeout(() => { this.videoModal = true; }, 3000);
    //setTimeout(() => { this.displayModal = true; }, 3000);
  },

}
</script>
<style>
  .video-icon{
    margin-left: 10px;
    cursor: pointer;
  }
.graph-data-container{
  margin-top: 20px;
}
.echarts{
  width: 100%;
}
.dropdowns-buttons{

    padding: 0 15px;
}
.mt20{
    margin-top:50px;
}
.no-margin{

    padding:0;
}
.regions-title .md-icon{
  margin-top: -8px;
}
.title-bread{
  background-color: #ddd ;
  border-radius: 4px;
  padding: 1px 5px;
  font-weight: bold;
  color:#667
}
.title-mobile {
  display: none;
}
@media only screen and (max-width: 600px) {
  .regions-title .title{
    display: block;
  }
  .title-mobile {
    display: block;
    margin-top: 20px;
  }
  .info-icon-comparative{
    position: absolute;
    left: 0;
    top: 18px;
  }
}
</style>

